export const FUSION_URL = {
  DX_SEARCH: 'v1/diagnosis/search',
  EXPORT_EXCEL: 'v1/encounter/export/excel',
  EXPORT_EXCEL_DETAILED: 'v1/encounter/export/excel/detailed',
  PATIENT_INSURANCE: 'v1/patient/insurance/',
  PATIENT_INSURANCE_SEARCH: 'v1/patient/insurance/search?q=',
}
